export default {
  state: {
    show: false,
    showRefresh: false,
    text: "",
    textRefresh: "",
    event: undefined,
    createSlug: ''
  },
  mutations: {
    toggleSnackbar(state, obj) {
      state.text = obj.text;
      state.show = !state.show;
      state.event = obj.event;
      state.createSlug = obj.createSlug;
    },
    toggleSnackbarRefresh(state, obj) {
      state.textRefresh = obj.text;
      state.showRefresh = !state.showRefresh;
    }
  }
};
